import icon from './icon'

const menu = {
  'Teacher': {
    'lessons': {
      name: 'all_courses',
      icon: icon.star,
      active: icon.starWhite
    },
    'course-mgr': {
      name: 'assignment',
      icon: icon.book,
      active: icon.bookWhite
    },
    'exam-mgr': {
      name: 'my_test',
      icon: icon.pen,
      active: icon.penWhite
    },
    'group-mgr': {
      name: 'class_management',
      icon: icon.pencil,
      active: icon.pencilWhite
    },
    'record-mgr': {
      name: 'learning_record_mgr',
      icon: icon.award,
      active: icon.awardWhite
    }
  },
  'Student': {
    'lessons': {
      name: 'all_courses',
      icon: icon.star,
      active: icon.starWhite
    },
    'quiz': {
      name: 'assessment_test',
      icon: icon.doc,
      active: icon.docWhite
    },
    'works': {
      name: 'assignment',
      icon: icon.book,
      active: icon.bookWhite
    },
    'Exams': {
      name: 'my_test',
      icon: icon.pen,
      active: icon.penWhite
    },
    'lessons/history': {
      name: 'history',
      icon: icon.analytics,
      active: icon.analytics
    }
  },
  'common': {}
}

export default menu



// WEBPACK FOOTER //
// ./src/menu.js